/**
 * Sprint P32 · Snapshot bridge for the Cockpit R3F canvas.
 * `useSnapshot` renders the scene once and returns a PNG blob.
 * `SnapshotBridge` invokes `onReady` once with the callback.
 */
import { useEffect } from "react";
import { useThree } from "@react-three/fiber";


export function useSnapshot() {
  const { gl, scene, camera } = useThree();
  return () => {
    gl.render(scene, camera);
    return new Promise((resolve) =>
      gl.domElement.toBlob((blob) => resolve(blob), "image/png", 0.92));
  };
}


export function SnapshotBridge({ onReady }) {
  const take = useSnapshot();
  useEffect(() => { onReady(take); }, [take, onReady]);
  return null;
}
